export default __webpack_public_path__ + "static/mreavesmodot-9cd465811ae16bc6c775d4d9e822faf5.woff";